export default __webpack_public_path__ + "static/media/busd.171a77d8.png";